/**
 * @author vishwadeep.kapoor
 * @Date: 2020-10-06 17:17:14
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-10-08 15:43:55
 */

import Loadable from 'react-loadable';
import { Loader } from '../../../components';

const component = Loadable({
  loader: () => import('./index'),
  loading: Loader,
});

const loadData = (store, params) => ( // eslint-disable-line no-unused-vars
  Promise.all([
    // store.dispatch(fetchSomething(params))
  ])
);

export default {
  loadData,
  component,
};



// WEBPACK FOOTER //
// client/containers/Profile/CreateAccount/Loadable.js